"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NUMERICAL_REGEX = void 0;
var NUMERICAL_REGEX = exports.NUMERICAL_REGEX = new RegExp(/\D/g);